import { render, staticRenderFns } from "./PlanTable.vue?vue&type=template&id=6ba83abf&scoped=true&"
import script from "./PlanTable.vue?vue&type=script&lang=js&"
export * from "./PlanTable.vue?vue&type=script&lang=js&"
import style1 from "./PlanTable.vue?vue&type=style&index=1&id=6ba83abf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba83abf",
  null
  
)

export default component.exports